import {
  BANK_PAYMENT_BIC,
  BANK_PAYMENT_ACCOUNT_OWNER,
  BANK_PAYMENT_INSTITUTE,
  BANK_PAYMENT_IBAN,
} from '~~/constants/checkout';
import type { BankInfo } from '~~/types/checkout/BankInfo';
import type { RawCustomFields } from '~~/types/commercetools';

export default function (customFieldsRaw: RawCustomFields): Maybe<BankInfo> {

  if (!customFieldsRaw) {

    return;

  }
  const bankBic: string = customFieldsRaw.find(value =>
    value?.name === BANK_PAYMENT_BIC)?.value;

  const bankAccountOwner: string = customFieldsRaw.find(value =>
    value?.name === BANK_PAYMENT_ACCOUNT_OWNER)?.value;

  const bankInstitute: string = customFieldsRaw.find(value =>
    value?.name === BANK_PAYMENT_INSTITUTE)?.value;

  const bankIban: string = customFieldsRaw.find(value =>
    value?.name === BANK_PAYMENT_IBAN)?.value;

  return {
    bankBic,
    bankAccountOwner,
    bankInstitute,
    bankIban,
  };

}
